<template>
  <v-select
    return-object
    v-bind="$attrs"
    :items="availableItems"
    :label="label"
    v-model="selected"
    :item-text="itemText"
    item-value="ID"
    :clearable="clearable"
    :rules="rules"
    :loading="loading"
  >
    <template
      v-for="(_, scopedSlotName) in $scopedSlots"
      v-slot:[scopedSlotName]="slotData"
    >
      <slot :name="scopedSlotName" v-bind="slotData" />
    </template>
    <template v-for="(_, slotName) in $slots" v-slot:[slotName]>
      <slot :name="slotName" />
    </template>
  </v-select>
</template>
<script>
import { get, sync, commit, call } from 'vuex-pathify'
export default {
  name: 'select-luAgencyRole',
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    label: {
      type: String,
      default: 'Agency Role',
    },
    value: Object,
    clearable: {
      type: Boolean,
      default: false,
    },
    rules: Array,
    items: Array,
  },
  data() {
    return {
      //templateFIX: if there is more than one pick one to display
      itemText: 'Description',
    }
  },
  computed: {
    ...get('luAgencyRole', ['luAgencyRoles', 'loading']),
    availableItems() {
      var list = []
      var fullList = []
      if (this.items) {
        fullList = this.items
        //if you have a property (like an IsActive boolean) you can change the true to filer i.e. i.IsActive
        list = this.items.filter((i) => true)
      } else {
        fullList = this.luAgencyRoles
        //if you have a property (like an IsActive boolean) you can change the true to filer i.e. i.IsActive
        list = this.luAgencyRoles.filter((i) => true)
      }
      list = list.filter((i) => i.IsActive)
      // if existing record make sure the previous selection is available even if no longer active
      if (this.value && this.value.ID && this.value.ID > 0) {
        var selectedItem = fullList.find((i) => i.ID == this.value.ID)
        if (!list.find((i) => i.ID == this.value.ID) && selectedItem) {
          list.push(selectedItem)
        }
      }
      // sort by column
      list.sort((a, b) => {
        var roleOrder = [1, 5, 2, 3, 4]
        //set the property to sort on
        let sort = roleOrder.indexOf(a.ID) > roleOrder.indexOf(b.ID) ? 1 : -1
        return sort
      })
      return list
    },
    selected: {
      get() {
        if (this.value) {
          return this.value
        } else {
          return null
        }
      },
      set(newValue) {
        this.$emit('change', newValue)
      },
    },
  },
  created() {
    if (!this.items) {
      this.loadLuAgencyRoles()
    }
  },
  methods: {
    loadLuAgencyRoles: call('luAgencyRole/loadLuAgencyRoles'),
  },
}
</script>
<style>
</style>